import { render, staticRenderFns } from "./GroupOverview.vue?vue&type=template&id=6cf37030&scoped=true&"
import script from "./GroupOverview.vue?vue&type=script&lang=js&"
export * from "./GroupOverview.vue?vue&type=script&lang=js&"
import style0 from "./GroupOverview.vue?vue&type=style&index=0&id=6cf37030&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf37030",
  null
  
)

export default component.exports